<template>
  <form @submit.prevent="submit" class="space-y-4 lg:space-y-8">
    <!--  Contact data section -->
    <section class="grid grid-cols-6 gap-6">
      <header class="col-span-6">
        <h3 class="text-lg ">{{ headerText }}</h3>
      </header>
      <section class="col-span-6 lg:col-span-3">
        <label class="block text-sm font-medium"
               for="fullname"
        >{{ localise.input_label_fullname[lang] }}
          <span class="text-red-700 text-xs">*</span>
        </label>
        <input v-model="fullname"
               id="fullname"
               autocomplete="family-name"
               class="w-full input-md"
               required
               type="text"
               @input="validate"
        >
      </section>

      <div class="col-span-6 lg:col-span-3">
        <label class="block text-sm font-medium"
               for="emailaddress"
        >{{ localise.input_label_email[lang] }}
          <span v-show="mailcopy"
                class="text-red-700 text-xs"
          >*</span>
        </label>
        <input v-model="emailaddress"
               id="emailaddress"
               autocomplete="email"
               type="text"
               :required="mailcopy"
               class="w-full input-md"
               @input="validate"
        >
      </div>

      <div class="col-span-6">
        <label for="subject"
               class="block text-sm font-medium"
        >{{ localise.input_label_subject[lang] }}
        </label>
        <input v-model="subject"
               id="subject"
               type="text"
               autocomplete="subject"
               class="w-full input-md"
        >
      </div>

      <div class="col-span-6">
        <label class="block text-sm font-medium"
               for="about"
        >{{ localise.textfield_label_message[lang] }}
        </label>
        <div class="mt-1">
            <textarea v-model="about"
                      rows="3"
                      class="mt-1 block w-full input-md"
                      id="about"
            />
        </div>
      </div>

      <div class="col-span-6">
        <div class="mt-4 space-y-4">
          <div class="flex items-start">
            <div class="flex h-5 items-center">
              <input v-model="datenschutz"
                     id="datenschutz"
                     required
                     type="checkbox"
                     class="h-4 w-4 rounded border-slate-300 text-red-600 focus:ring-red-500 checked:bg-red-700"
                     @change="validate"
              >
            </div>
            <div class="ml-3 text-sm cursor-pointer" @click="datenschutz = !datenschutz">
              <label for="datenschutz"
                     class="font-medium"
              >{{ localise.checkbox_label_privacy[lang] }}
                <span class="text-red-700 text-xs">*</span>
              </label>
              <br>
              <span class="text-slate-500 text-xs">{{ localise.checkbox_text_privacy[lang] }}<a :href="localise.checkbox_link_privacy[lang]">{{ localise.checkbox_link_privacy_label[lang] }}</a>.</span>
            </div>
          </div>
          <div>
            <div class="flex items-start">
              <div class="flex h-5 items-center">
                <input v-model="mailcopy"
                       id="checkBoxMailCopy"
                       type="checkbox"
                       class="h-4 w-4 rounded border-slate-300 text-red-600 focus:ring-red-500"
                       @change="validate"
                >
              </div>
              <div class="ml-3 text-sm cursor-pointer" @click="mailcopy = !mailcopy">
                <label for="checkBoxMailCopy"
                       class="font-medium"
                >{{ localise.checkbox_label_send_email_copy[lang] }}
                </label>
                <br>
                <span class="text-slate-500 text-xs">{{ localise.checkbox_text_send_email_copy[lang] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--  Submit button section -->
    <div class="grid grid-cols-6 gap-6">

      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <button type="submit"
                class=" group relative flex w-full justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                :disabled="!formIsValidated"
                :class="{'bg-green-600 hover:bg-green-600 focus:ring-green-500' : formsent,'bg-green-400 hover:bg-green-400 focus:ring-green-500' : senddata, 'bg-slate-400 hover:bg-slate-400 focus:ring-slate-500': !formIsValidated}"
        >
          {{ buttontext }}
        </button>
      </div>

    </div>
  </form>
</template>
<script setup>

import {ref} from "vue";
import localise from "../lang/localize.json"

const props = defineProps({
  headerText:{
    type: String,
    default: localise.section_header_contact.de
  },
  message:{
    type:String,
    default:''
  },
  lang: {
    type: String,
    default: 'de'
  }
})

const fullname = ref('');
const emailaddress = ref('');
const datenschutz = ref(true);
const mailcopy = ref(false);
const formsent = ref(false);
const subject = ref(props.message);
const about = ref('');
const senddata = ref(false)
const formIsValidated = ref(false)
const buttontext = ref(localise.btn_text_send_message[props.lang])

const validate = () => {

  formIsValidated.value = (mailcopy.value)
      ? datenschutz.value && fullname.value.length > 0 && emailaddress.value.length > 0
      : datenschutz.value && fullname.value.length > 0

}

const submit = async () => {
  formsent.value = true;
  senddata.value = true;
  buttontext.value = localise.btn_text_sending_message[props.lang];

  fetch(
      'https://api.thermo-control.com/v1/send-contact-mail',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          api_key: 'KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q',
          fullname: fullname.value,
          emailaddress: emailaddress.value,
          subject: subject.value,
          about: about.value,
          datenschutz: datenschutz.value,
          mailcopy: mailcopy.value,
        })
      }
  ).then(response => response.json())
      .then(data => {
        senddata.value = false;
        formsent.value = data.formsent;
        buttontext.value = (data.formsent) ? localise.btn_text_message_success[props.lang] : localise.btn_text_send_message[props.lang];
        setTimeout(() => {
          formsent.value = false;
          buttontext.value = localise.btn_text_send_new_message[props.lang];
        }, 3000)
      })


  /*   const messages = JSON.parse(localStorage.getItem("messages"));
     const { name, phonenumber} = this;
     messages.push({
       name,
       phonenumber,
     });
     localStorage.setItem("messages", JSON.stringify(messages));*/
}
</script>